import {Post} from "../server";

export function list(data= []) {
    return Post("/api1/robotApi/list", data);
}


export function remove(data) {
    return Post("/api1/robotApi/delete", data);
}

export function save(data) {
    return Post("/api1/robotApi/add", data);
}

export const robotApi = {
    list,
    remove,
    save
}